import React, { useContext, useEffect, useState } from 'react';

import { TableBody } from '@material-ui/core';

import { GlobalContext } from '../../../../../../../../../store';

import {
  useAssignResultsDispatch,
  useAssignResultsState
} from '../../../../../../Common/AssignResults/Context/AssignResults.context';
import { CTPTableRow } from './CTPTableRow';

interface ICTPTableBody {
  roundId: number;
}

export const CTPTableBody = (props: ICTPTableBody) => {
  const { roundId } = props;
  const { adminHoleResults } = useContext(GlobalContext);
  const { ctpResults, selectedCombination } = useAssignResultsState();

  const {
    actions: { setCTPResults }
  } = useAssignResultsDispatch();

  const [ctpHoles, setCtpHoles] = useState<number[]>([]);

  useEffect(() => {
    if (selectedCombination) {
      setCTPResults(adminHoleResults, roundId, selectedCombination.format.considerFlights);
    }
  }, [adminHoleResults, selectedCombination]);

  useEffect(() => {
    if (
      selectedCombination &&
      roundId &&
      selectedCombination.format.metadata &&
      selectedCombination.format.metadata[roundId]
    ) {
      setCtpHoles(selectedCombination.format.metadata[roundId]);
    }
  }, [selectedCombination]);

  return (
    <TableBody className="results-table-table-body">
      {Object.keys(ctpResults)
        .filter((hole: string) => ctpHoles.includes(Number(hole) + 1))
        .map((hole: string, index: number) => (
          <CTPTableRow
            ctpResults={ctpResults}
            key={`CTPTableRow-${index}`}
            index={index}
            hole={hole}
            roundId={roundId}
          />
        ))}
    </TableBody>
  );
};
